<div class="sidebar-wrapper">
  <app-sidebar-header (backButtonClicked)="goBack()" [showBackButton]="true">
    <div smallTitle>{{ isEdit ? 'Edit ' : 'Add ' }} Change Action</div>
    <div mainTitle>General Information</div>
  </app-sidebar-header>

  <form #PCOForm="ngForm" role="form" class="main-content flex flex-col">
    <app-search-input
      (searchText)="onSearch($event)"
      placeholder="Search PCOs by name or ID..."
      label=""
    ></app-search-input>

    @if (allPCOs().length > 0) {
      <div class="flex items-center gap-6 px-2 min-h-14">
        <app-checkbox
          type="square"
          [name]="'pco_checkbox_all'"
          [ngModel]="selectedPCOIdsInternal().length === allPCOs().length"
          [binary]="true"
          (onChange)="toggleAllPCOs($event)"
          [disabled]="isLoading()"
        ></app-checkbox>
        <div class="text-navy-900 font-bold text-base">PCO Title</div>
        <div class="text-navy-900 font-bold ml-auto flex justify-center w-20">Confirmed</div>
      </div>
      <div class="border-b border-b-solid border-navy-300"></div>
    }

    <app-loading-bar
      class="w-full z-10"
      [ngClass]="{ 'opacity-0': !isLoading() }"
      mode="indeterminate"
    ></app-loading-bar>

    <div
      appScrolledToBottom
      (scrolledToBottom)="scrolledToBottom($event)"
      class="sk-scrollbar flex-1 min-h-0 overflow-auto"
    >
      @for (pco of allPCOs(); track pco.id) {
        <div class="flex items-center gap-6 my-2 px-2">
          <app-checkbox
            type="square"
            [binary]="false"
            [name]="'pco_checkbox_' + pco.id"
            [value]="pco.id"
            (ngModelChange)="togglePCO(pco)"
            [ngModel]="selectedPCOIdsInternal()"
            [inputId]="String(pco.id)"
            [disabled]="isLoading()"
          ></app-checkbox>
          <app-faded-text [displayGrid]="true">
            <div class="flex max-w-72 flex-col text-navy-900 font-semibold text-sm">
              <span>{{ pco?.number ?? '-' }}</span>
              <span>{{ pco.title }}</span>
            </div>
          </app-faded-text>
          <div
            [class.negative]="pco.commitment_dollars < 0"
            class="ml-auto flex justify-center min-w-20 text-navy-900 font-semibold text-sm text-center"
          >
            {{ pco.commitment_dollars | money: 'positiveComa' }}
          </div>
        </div>
        <div class="border-b border-b-solid border-navy-300"></div>
      } @empty {
        <div class="flex items-center justify-center h-20">
          <span class="font-bold">No available PCOs.</span>
        </div>
      }
    </div>
  </form>
  <div class="mt-auto flex flex-col mx-8 mb-1">
    <div class="border-b border-b-solid border-navy-300"></div>

    <div class="flex justify-between my-5">
      <span class="text-navy-900 font-bold text-sm">Total PCOs Selected</span>
      <span class="text-navy-900 font-bold text-sm" [class.negative]="totalPCOs() < 0">
        {{ totalPCOs() | money: 'positiveComa' }}</span
      >

      <app-simple-button (click)="submitForm()" [disabled]="isLoading()" buttonStyle="color_accent_filled">
        {{ isEdit ? 'Update' : 'Save' }}
      </app-simple-button>
    </div>
  </div>
</div>
